import React, { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { Send } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import VoiceInput from "@/components/VoiceInput";

export default function ProjectChat({ projectId }) {
  const [messages, setMessages] = useState([]);
  const [text, setText] = useState("");
  const endRef = useRef(null);
  const { user } = useAuth();

  const load = async () => {
    try { const { data } = await api.get(`/projects/${projectId}/chat`); setMessages(data); }
    catch { setMessages([]); }
  };
  useEffect(() => { load(); const id = setInterval(load, 10000); return ()=>clearInterval(id); }, [projectId]);
  useEffect(() => { endRef.current?.scrollIntoView({ behavior: "smooth" }); }, [messages]);

  const send = async () => {
    if (!text.trim()) return;
    try { await api.post(`/projects/${projectId}/chat`, { body: text }); setText(""); load(); }
    catch {}
  };

  return (
    <div className="flex flex-col h-[500px] bg-white rounded-md border border-slate-200">
      <div className="px-4 py-3 border-b border-slate-100 font-heading font-semibold text-navy-900 text-sm">Chat di gruppo · Team del progetto</div>
      <div className="flex-1 overflow-y-auto p-4 space-y-3">
        {messages.length === 0 && <div className="text-sm text-slate-400 text-center mt-12">Inizia la conversazione del team.</div>}
        {messages.map(m => {
          const mine = m.author_id === user?.id;
          const initials = (m.author_name || "?").split(" ").map(s=>s[0]).slice(0,2).join("");
          return (
            <div key={m.id} className={`flex gap-2 ${mine ? "flex-row-reverse" : ""}`} data-testid={`chat-msg-${m.id}`}>
              <Avatar className="w-7 h-7 flex-shrink-0"><AvatarFallback className="bg-navy-800 text-white text-[10px]">{initials}</AvatarFallback></Avatar>
              <div className={`max-w-[75%] ${mine ? "items-end" : "items-start"} flex flex-col`}>
                <div className="text-[11px] text-slate-500 px-1">
                  <span className="font-medium text-navy-900">{m.author_name}</span> · {new Date(m.created_at).toLocaleString("it-IT", { hour:"2-digit", minute:"2-digit", day:"2-digit", month:"2-digit" })}
                </div>
                <div className={`px-3 py-2 rounded-lg text-sm whitespace-pre-line ${mine ? "bg-navy-800 text-white rounded-tr-sm" : "bg-slate-100 text-slate-800 rounded-tl-sm"}`}>{m.body}</div>
              </div>
            </div>
          );
        })}
        <div ref={endRef} />
      </div>
      <div className="border-t border-slate-100 p-3 flex gap-2">
        <Input value={text} onChange={(e)=>setText(e.target.value)} onKeyDown={(e)=>e.key==="Enter"&&send()} placeholder="Scrivi un messaggio al team..." data-testid="chat-input" />
        <VoiceInput onTranscript={(t)=>setText((p)=>(p?p+" ":"")+t)} />
        <Button onClick={send} className="bg-navy-800 hover:bg-navy-900" data-testid="chat-send"><Send className="w-4 h-4" /></Button>
      </div>
    </div>
  );
}
